import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Coins } from "lucide-react";
import { api, formatDate, rupiah } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { PageLoader } from "@/components/layout/RequireAuth";

export default function Credits() {
  const [data, setData] = useState(null);
  const [packages, setPackages] = useState([]);
  useEffect(() => {
    api.get("/provider/credits").then((r) => setData(r.data));
    api.get("/settings/public").then((r) => setPackages(r.data.credit_packages || []));
  }, []);
  if (!data) return <PageLoader />;

  return (
    <div className="container-page max-w-3xl py-10 lg:py-14" data-testid="credits-page">
      <p className="eyebrow">Penyedia</p>
      <h1 className="mt-2 text-3xl font-bold tracking-tight text-stone-900 sm:text-4xl">Kredit</h1>
      <div className="card-soft mt-8 flex items-center gap-4 p-6 sm:p-8">
        <span className="flex h-14 w-14 items-center justify-center rounded-2xl bg-amber-50 text-amber-700"><Coins className="h-6 w-6" /></span>
        <div>
          <p className="text-sm text-stone-500">Saldo kredit</p>
          <p className="text-3xl font-extrabold text-stone-900" data-testid="credits-balance">{data.balance} kredit</p>
        </div>
      </div>
      <h2 className="mt-10 text-lg font-bold text-stone-900" id="beli">Beli Kredit</h2>
      <div className="mt-4 grid gap-4 sm:grid-cols-3" data-testid="credit-packages">
        {packages.map((p) => (
          <div key={p.key} className="card-soft flex flex-col p-6" data-testid={`credit-package-${p.key}`}>
            <p className="text-3xl font-extrabold text-stone-900">{p.credits}</p>
            <p className="text-sm text-stone-500">kredit</p>
            <p className="mt-3 font-bold text-stone-900">{rupiah(p.price)}</p>
            <p className="text-xs text-stone-500">{rupiah(Math.round(p.price / p.credits))} / kredit</p>
            <Button asChild className="mt-5 rounded-xl bg-teal-700 hover:bg-teal-800" data-testid={`buy-credit-${p.key}`}>
              <Link to={`/bayar?kredit=${p.key}`}>Beli</Link>
            </Button>
          </div>
        ))}
      </div>
      <h2 className="mt-10 text-lg font-bold text-stone-900">Riwayat kredit</h2>
      <div className="card-soft mt-4 divide-y divide-stone-100" data-testid="credits-ledger">
        {data.ledger.map((e) => (
          <div key={e.entry_id} className="flex items-center justify-between gap-4 px-6 py-4" data-testid={`ledger-entry-${e.entry_id}`}>
            <div>
              <p className="text-sm font-medium text-stone-800">{e.note}</p>
              <p className="text-xs text-stone-500">{formatDate(e.created_at)}</p>
            </div>
            <span className={`text-sm font-bold ${e.delta > 0 ? "text-emerald-700" : "text-stone-700"}`}>{e.delta > 0 ? `+${e.delta}` : e.delta}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
